import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import support from '../../assets/images/support.png'
import atention from '../../assets/images/attention.png'
import application from '../../assets/images/application.png'

const BeneficiosList = () => {
  return (
    <>
      <div className="media">
        <img src={support} alt="support" />
        <div className="media-body">
          <h5 className="mt-0">El mejor precio</h5>
          <p>
            Compara con todas las aseguradoras de México y encuentra el mejor
            seguro para tus necesidades.
          </p>
        </div>
      </div>
      <div className="media">
        <img src={atention} alt="attention" />
        <div className="media-body">
          <h5 className="mt-0">Atención 24/7</h5>
          <p>
            Nuestros usuarios cuentan con nuestros servicios 24 horas al día los
            365 días del año.
          </p>
        </div>
      </div>
      <div className="media">
        <img
          src={application}
          alt="application"
        />
        <div className="media-body">
          <h5 className="mt-0">Aplicación móvil</h5>
          <p>
            Utiliza la aplicación móvil para reportar siniestros, recibir
            notificaciones de pago y tener toda tu información disponible en
            todo momento.
          </p>
        </div>
      </div>
    </>
  );
};

export default BeneficiosList;
